<template>
  <div class="searchbar">
    <div>
      <ul>
        <li>Trier par :</li>
        <li>
          <form class="m-t-10" role="form">
            <div class="form-group form-group-default form-group-default-select2 selection-class">
              <label>Groupes</label>
              <select class=" full-width dropdown-multiselect" multiple>
                <option value="ABC">ABC+</option>
                <option value="SDM">SDM</option>
                <option value="Sofradom">Sofradom</option>
              </select>
            </div>
          </form>
        </li>
        <li>
          <form class="m-t-10" role="form">
            <div class="form-group form-group-default form-group-default-select2 selection-class">
              <label>Agences</label>
              <select class=" full-width dropdown-multiselect" multiple>
                <option value="opera">Agence Opéra</option>
                <option value="bastille">Agence Bastille</option>
                <option value="montreuil">Agence Montreuil</option>
              </select>
            </div>
          </form>
        </li>
      </ul>
      <ul>
        <li class="checkbox check-complete">
          <input type="checkbox" id="cbox1" value="Colis">
          <label for="cbox1">Colis</label>
        </li>
        <li class="checkbox check-complete">
          <input type="checkbox" id="cbox2" value="procuration">
          <label for="cbox2">Procuration</label>
        </li>
        <li class="checkbox check-complete">
          <input type="checkbox" id="cbox3" value="courrier">
          <label for="cbox3">Courrier bloqué</label>
        </li>
        <li class="checkbox check-complete">
          <input type="checkbox" id="cbox4" value="annule">
          <label for="cbox4">Annulé</label>
        </li>
      </ul>
    </div>
    <button class="btn btn-complete btn-cons">Ajouter un contrat</button>
  </div>
</template>

<style lang="scss" scoped>
  .searchbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    padding-top: 10px;
    div {
      display: flex;
      flex-wrap: wrap;
      ul {
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        li {
          display: inline-block;
          list-style-type: none;
          margin-right: 5px;
        }
      }
    }
    button {
      min-width: 150px;
    }
  }
  .selection-class {
    min-width: 100px;
  }
</style>

<script type="text/babel">
  export default {
    mounted () {
      $('.dropdown-multiselect').select2()
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/DomiciliationContractsList/SearchBar.vue